import $ from 'jquery';
import AlertService from '../common/alert/AlertService';
import translate from '../common/localization/translate';

function getNewDateObj(dateString) {
  const year = parseInt(dateString.substr(0, 4), 10);
  const month = parseInt(dateString.substr(5, 2), 10) - 1;
  const day = parseInt(dateString.substr(8, 2), 10);
  const hour = parseInt(dateString.substr(11, 2), 10) || 0;
  const minutes = parseInt(dateString.substr(14, 2), 10) || 0;
  const seconds = parseInt(dateString.substr(17, 2), 10) || 0;

  return new Date(year, month, day, hour, minutes, seconds);
}

function isErrorResponse(response) {
  if (response && response.error) {
    const errorMessage = response.message ?? translate('javascript.LBL_UNKNOWN_ERR');
    AlertService.showError(errorMessage);
    return true;
  }
  return false;
}

function closePopupMenus() {
  $('.control-options-menu').hide();
  $('.dropdown-menu').dropdown('hide');
}

const VcomHelperService = {
  getNewDateObj,
  isErrorResponse,
  closePopupMenus,
};

export default VcomHelperService;
